import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "api/queryKeys"
import { useAuthedAxios } from "hooks/core/useAuthedAxios"
import { loadRouting, RoutingResult } from "./routingProvider"

/**
 * The project's routing, kept for the session of the screen. It is read
 * again every time the screen opens: the data or the routing may have
 * changed since the last visit, and a cached routing would give bases and
 * counts of the earlier state.
 */
export const useRouting = (
  projectId: string,
  owner: string,
  variant: string | null,
  enabled = true
) => {
  const getAxios = useAuthedAxios()
  return useQuery<RoutingResult>({
    queryKey: [...queryKeys.tabSpecs.root, projectId, owner, "routing", variant ?? ""],
    queryFn: async () => loadRouting(await getAxios(), projectId, owner, variant),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
    refetchOnMount: "always",
    retry: false,
  })
}
